export const getIconFor = (featureKey, countryCode, icons) => {
    const iconKey = featureKey.replace(".", "_");
    return icons[`${iconKey}_${countryCode}`] || icons[iconKey];
};
export const useIconFor = getIconFor;
